import { render, staticRenderFns } from "./CustomerAdvocate3.vue?vue&type=template&id=0f2d03b0&"
import script from "./CustomerAdvocate3.vue?vue&type=script&lang=js&"
export * from "./CustomerAdvocate3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports